import React from 'react';
import { Spin, Modal } from 'antd';

const Loading: React.FC<any> = (props) => {

  const { loading } = props

  return (
    <div>
      <Modal
        visible={loading}
        modalRender={() => <Spin size="large" />}
        width={64}
        centered={true}
      />
    </div>
  );
}

export default Loading